import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=survey；独立窗正式 key/path 为 questionnaire */
export const questionnaireModule: AiAppCenterModule = {
  key: 'questionnaire',
  label: '问卷调查',
  desc: '问卷设计 / 数据采集 / 结果分析',
  path: '/questionnaire',
  standalonePath: '/questionnaire/dashboard',
  homePath: '/questionnaire/dashboard',
  // 侧栏业务菜单仍挂在后端 /survey 下
  menuPaths: ['/survey'],
  icon: 'ep:edit-pen',
  color: '#a855f7',
  aliases: ['调卷问查', '调查问卷', 'AI问卷调查']
}
